/**
 * Browser entry point. Styles, then the app — nothing else belongs here.
 *
 * `base.css` pulls in the fonts and the design tokens, so it must be imported before
 * the first component renders or the initial paint would use the fallback stack.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import "@/styles/base.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
